import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import SurfaceTypeSelect from 'components/formElements/SurfaceTypeSelect';
import AssigneeSelect from 'components/formElements/AssigneeSelect';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import { handleDateSave } from '../../../../../../../utils/dateUtils.js';
import reportStyle from 'styles.scss';

class InstallWorkorderFilters extends React.Component {
  constructor(props) {
    super(props);

    const startingState = {
      workrooms: props.location.query.workrooms || [],
      surface_types: props.location.query.surface_types || [],
      assignee_id: parseInt(props.location.query.assignee_id, 10) || null,
      assignee_type: props.location.query.assignee_type || '',
      start_date: props.location.query.start_date || moment().format('YYYY-MM-DD'),
      end_date: props.location.query.end_date || moment().format('YYYY-MM-DD'),
      error: '',
    };

    this.state = startingState;
    this.handleWorkrooms = this.onSelectChange.bind(this, 'workrooms');
    this.handleSurfaceTypes = this.onSelectChange.bind(this, 'surface_types');
  }

  onStartDateChange = date =>
    this.setState({ start_date: handleDateSave(date) });

  onEndDateChange = date =>
    this.setState({ end_date: handleDateSave(date) });

  onAssigneeChange = (val) => {
    this.setState({
      assignee_id: this.getAssigneeChangeValue(val, 'employable_id') || null,
      assignee_type: this.getAssigneeChangeValue(val, 'employable_type') || null,
    });
  }

  onSelectChange(key, value) {
    const stateVal = value.map(v => v.value);
    this.setState({ [key]: stateVal });
  }

  setError = () => this.setState({ error: 'Please select a workroom' });

  getAssigneeChangeValue = (val, key) => (val ? val[key] : null)

  submit = (e) => {
    e.preventDefault();

    const { workrooms, surface_types, assignee_id, assignee_type } = this.state;
    if (workrooms === undefined || workrooms.length === 0) return this.setError();
    const query = { ...this.state };

    delete query.error;
    if (!surface_types || surface_types.length === 0) delete query.surface_types;
    if (!assignee_id || !assignee_type) {
      delete query.assignee_id;
      delete query.assignee_type;
    }

    if (this.props.onSubmit) return this.props.onSubmit(query);
    return this.props.push({ pathname: this.props.location.pathname, query });
  }

  render() {
    const { start_date, end_date, workrooms, error, surface_types } = this.state;
    const startDate = moment(start_date).format('MM/DD/YYYY');
    const endDate = moment(end_date).format('MM/DD/YYYY');

    return (
      <form onSubmit={this.submit} className={reportStyle.form}>
        <WorkroomSelect
          className={reportStyle.formElement}
          multi
          resetValue={[]}
          onChange={this.handleWorkrooms}
          value={workrooms}
          error={error}
          required
        />
        <DatePicker
          className={reportStyle.formElement}
          label="Start Date"
          value={startDate}
          onChange={this.onStartDateChange}
          placeholder="Select Start Date"
          required
        />
        <DatePicker
          className={reportStyle.formElement}
          label="End Date"
          value={endDate}
          onChange={this.onEndDateChange}
          placeholder="Select End Date"
          required
        />
        <SurfaceTypeSelect
          className={reportStyle.formElement}
          multi
          resetValue={[]}
          onChange={this.handleSurfaceTypes}
          value={surface_types}
          placeholder="All Surfaces"
        />
        {this.props.children}
        <AssigneeSelect
          multi={false}
          className={reportStyle.assigneeFormElement}
          onChange={this.onAssigneeChange}
          placeholder="All Installers/Employees"
        />
        <ColoredButton type="submit" className={reportStyle.formSubmit}>Run Report</ColoredButton>
      </form>
    );
  }
}

InstallWorkorderFilters.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.shape({
      workrooms: PropTypes.array,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
      surface_types: PropTypes.array,
      assignee_id: PropTypes.string,
      assignee_type: PropTypes.string,
    }),
  }).isRequired,
  push: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
};

export default connect(() => ({}), { push })(InstallWorkorderFilters);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/installWorkorderReport/components/InstallWorkorderFilters/index.jsx